import React, { FunctionComponent } from 'react';
import { PersonShowSidebarItem } from '../../molecules/personShowSidebarItem';

type Props = {
  isPc: boolean;
  isShow: boolean;
  mail: string;
  tel: string;
  twitter: string;
  instagram: string;
  penIconImg: string;
  personId: number;
  handleClick: (target: string, title: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  isPc,
  isShow,
  mail,
  tel,
  twitter,
  instagram,
  penIconImg,
  personId,
  handleClick,
}) => {
  return (
    <div className="person__show__sidebar">
      <hr className="person__show__sidebar--devide" />
      <h2 className="mainTitle">連絡先情報</h2>
      <PersonShowSidebarItem
        penIconImg={penIconImg}
        title="電話番号"
        value={tel}
        id="tel"
        handleClick={handleClick}
        isShow={isShow}
        word="追加する"
      />
      <PersonShowSidebarItem
        penIconImg={penIconImg}
        title="メールアドレス"
        value={mail}
        id="mail"
        handleClick={(target, title) => { window.location.href = `/users/${personId}/preference/edit?open=email`; }}
        isShow={isShow}
        word="追加する"
      />
      <hr className="person__show__sidebar--devide" />
      <h2 className="mainTitle">SNS連携</h2>
      <PersonShowSidebarItem
        penIconImg={penIconImg}
        title="（旧Twitter）"
        value={twitter}
        id="twitter"
        handleClick={handleClick}
        isShow={isShow}
        word="追加する"
      />
      <PersonShowSidebarItem
        penIconImg={penIconImg}
        title="Instagram"
        value={instagram}
        last={true}
        id="instagram"
        handleClick={handleClick}
        isShow={isShow}
        word="追加する"
        isPc={isPc}
      />
    </div>
  );
};
